import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Navigation, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ShareLocationButton({ job }) {
  const [on, setOn] = useState(false);
  const [sent, setSent] = useState(0);
  const watchRef = useRef(null);
  const lastRef = useRef(0);

  const stop = () => { if (watchRef.current != null) navigator.geolocation?.clearWatch(watchRef.current); watchRef.current = null; setOn(false); };
  useEffect(() => () => stop(), []);
  useEffect(() => { if (!["claimed", "picked_up"].includes(job.status)) stop(); }, [job.status]);

  const start = () => {
    if (!navigator.geolocation) return toast.error("Location not supported on this device");
    setOn(true);
    watchRef.current = navigator.geolocation.watchPosition(async (pos) => {
      if (Date.now() - lastRef.current < 8000) return;
      lastRef.current = Date.now();
      const { latitude: lat, longitude: lng, heading, speed } = pos.coords;
      try { await api.post(`/gigs/jobs/${job.job_id}/location`, { lat, lng, heading: heading ?? null, speed_mph: speed != null ? speed * 2.237 : null }); setSent((n) => n + 1); } catch { stop(); }
    }, () => { toast.error("Location permission denied"); stop(); }, { enableHighAccuracy: true, maximumAge: 5000 });
  };

  return (
    <Button size="sm" variant="outline" onClick={on ? stop : start} data-testid={`job-share-location-${job.job_id}`}
      className={`bg-transparent h-8 text-xs ${on ? "border-amber-500/50 text-amber-300" : "border-slate-700 text-slate-300"}`}>
      {on ? <><Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" />Sharing live ({sent})</> : <><Navigation className="w-3.5 h-3.5 mr-1" />Share live location</>}
    </Button>
  );
}
